// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG } from "common/config";
import { COMMON_JS } from "common/scripts";

export const REPORT_APIs = {
  getCustomerTypeReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/3H5PUTSBPUFG5EL6",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCustomerReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/E3Z911JD87IJFWOB",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getAreaSalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/FME20ASSCMXPE63J",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCitySalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/EN0VE48EVTCHE4U3",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getRegionSalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/VCUUEBNAUXH54M07",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getStateSalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/G9YKIX7E1QX4D1WB",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getProductSalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/0M0RVCUPN3SU043U",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getSubCategorySalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/BGWL9P9KFEZII4D6",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getMainCategorySalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/9CCXGMX5PABM4C0L",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCategorySalesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/XRT1YYY56XYM3C0L",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getSchemeUtilizationReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/WNT5YDZ9M92LC3LW",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getSchemesReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/5CRQWRUHR56NHXMN",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getTargetsReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/B43OH9XOSFZCT1Z6",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getTotalTargetStatusReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/TKVTYL6P1V7DKV5J",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getProductTargetStatusReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/0QBUQCLX2SR5KT08",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getOrderDetailReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/C29UHVCNX81ZP312",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getBeatOrderReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/0NCPSLXKORUV0BPB",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getTeamReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/IIQTKPZDSXTXG4J7",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCityList: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/PXK2SBMZH8A1WD8F",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getProductsReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/RAKW5XEL3PRKE8R1",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getAllLogsRegister: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/3ZH3C254DU6EE6LD",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getUserDetailedLog: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/883Y5851A13563IH",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getAreaList: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/XGF94VWQN7J94CNP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getPriceListReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/FVX7SBHH4KBQATB7",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCrmLeadReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/HCJ4PAPSAWA2T6Y0",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getFeedbackReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/63IL9SW3DTYT9JX8",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getInstructionReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/YWS6V5RDJ51O2PRP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getSurveyReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/1HCTO1NUHV5O5Z6Q",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCustomerList: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/1N93YNBAR5M8QQKJ",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getLeaveReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/OW73GZWPXT4JDGGK",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getAttendanceReport: async (args = {}, accessToken = "") => {
    const response = await COMMON_JS.callApi(
      "/re/v1/AJLG2MY74KEB622K",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCustomerOrders: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/re/v1/OWBV161Y2H0A3Q75",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Get monthly sales details
  getSalesMonthly: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/re/v1/631I2314N61107YP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Get
  getRouteReport: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/re/v1/XGF94VWQN7J94CNP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Get message report
  getGeoDrillDownReport: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/re/v1/getgeodilldown",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
